var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Home6"},[(_vm.drawershow == 'true')?_c('div',{staticClass:"news-pc"},[_c('Main',{attrs:{"name":_vm.name,"drawershow":_vm.drawershow}})],1):_c('div',{staticClass:"news-mobile"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }